<template>
<div class="chapter">
<div class="inner_page">
<h1 class="GFP_FM_Header">Alstead, Maine</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter.vue?4a2326b6